<div class="row forms_area">
    <div class="progress"></div>
    <div class="card">
        <div class="card_header">
            <div class="row row_jc_space_btw row_ai_center">
                <p class="title fz_l fw_700">Подтверждение оплаты</p>
            </div>
        </div>
        <div class="card_body fz_s">
            <div class="row">
                <div class="col-10 user_details">
                    <div class="row row_ai_center"><span class="material-symbols-outlined color_text_gray">
                            person
                        </span> {{order.firstname}} {{order.lastname}}</div>
                    <div class="row row_ai_center"><span class="material-symbols-outlined color_text_gray">
                            call
                        </span><a href="tel:{{order.phone}}">{{order.phone}}</a></div>
                    <div class="row row_ai_center"><span class="material-symbols-outlined color_text_gray">
                            alternate_email
                        </span><a href="mailto:{{order.email}}"> {{order.email}}</a></div>
                    <div class="row row_ai_center"><span class="material-symbols-outlined color_text_gray">
                        payments
                    </span>{{order.address.street}}, {{order.address.city}}, {{order.address.state}} {{order.address.postalCode}}</div>
                    <div *ngIf="requireShipping" class="row row_ai_center"><span class="material-symbols-outlined color_text_gray">
                        delivery_truck_speed
                    </span>{{order.shippingAddress.street}}, {{order.shippingAddress.city}}, {{order.shippingAddress.state}} {{order.shippingAddress.postalCode}}</div>
                </div>
                <div class="col-14 product_details">
                    <div class="row fz_m">
                        <div class="col-9">Название</div>
                        <div class="col-5">Количество</div>
                        <div class="col-5">Скидка</div>
                        <div class="col-5">Сумма</div>
                    </div>
                    <div class="row" *ngFor="let product of order.products">
                        <div class="col-9">{{product.name}}</div>
                        <div class="col-5">{{product.quantity}}</div>
                        <div class="col-5">{{order.currency == 'usd' ? '$' : '€'}}{{product.discount}}</div>
                        <div class="col-5 row row_price"><span class="old_price" *ngIf="product.discount != 0 && (product.price * product.quantity != getTotalPrice(product))">{{order.currency == 'usd' ? '$' : '€'}}{{product.price * product.quantity}}</span><span class="new_price">{{order.currency == 'usd' ? '$' : '€'}}{{getTotalPrice(product)}}</span></div>
                    </div>
                    <div class="row" *ngIf="requireShipping">
                        <div class="col-9">Доставка</div>
                        <div class="col-5"></div>
                        <div class="col-5">{{order.currency == 'usd' ? '$' : '€'}}{{customFee.amount}}</div>
                        <div class="col-5">{{order.currency == 'usd' ? '$' : '€'}}{{customFee.amount}}</div>
                    </div>
                    <div class="row fz_m fw_600 total" >
                        <div class="col-9"></div>
                        <div class="col-5"></div>
                        <div class="col-5">Сумма:</div>
                        <div class="col-5">{{order.currency == 'usd' ? '$' : '€'}}{{getOrderTotal()}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
